import axios from "axios";
import environment from "../environment";
import { resetPersistedState } from "../redux/actions/actions";

const api = axios.create({});
export default api;

api.interceptors.request.use(async (config: any) => {
  //verifica se o redux está carregado e se o token está disponível
  const { store } = await import("../redux/store");
  const state = store.getState();
  const token = state.persisted.user.token;

  config.baseURL = environment.baseURL;
  config.headers = {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "", // Adiciona o token no header
  };
  return config;
});

//verifica se está logado, senão, retorna para o login
api.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  async (error) => {
    const { store } = await import("../redux/store");
    const state = store.getState();

    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if (error.response.status === 401) {
      store.dispatch(resetPersistedState());
      window.location.replace("/");
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);
